// TH.tsx
import { cn } from "helpers/classNames";
import React from "react";

interface Props extends React.HTMLAttributes<HTMLTableCellElement> {}

const TH: React.FC<Props> = (props) => {
  const classNames = cn(
    "px-3 py-3.5 text-left text-sm font-semibold text-gray-90",
    props.className || "",
  );

  return <th {...props} className={classNames} />;
};

export default TH;
